import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { Observable, delay, map, of, take } from 'rxjs';
import { WeekDay } from 'src/app/api/contracts/menu';
import { Order, OrderType } from 'src/app/api/contracts/order';
import { CartService } from 'src/app/services/cart.service';
import { InStoreProductsService } from 'src/app/services/in-store-products.service';
import { MealMenuService } from 'src/app/services/meal-menu.service';
import { OrderService } from 'src/app/services/order.service';
import { Cart } from 'src/app/types/cart';
import { WeekIndex } from 'src/app/types/menu';
import {
  getCurrentWeekNumber,
  getNextWeekNumber,
} from 'src/app/utils/date.utils';

@Component({
  selector: 'app-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.scss'],
})
export class OrderConfirmationComponent implements OnInit, OnDestroy {
  @Input() order!: Order;

  public readonly ORDER_TYPES = OrderType;
  public deliveryDays: Set<WeekDay> | null = null;
  public weeksInOrder$: Observable<Set<WeekIndex> | null> = of(null);

  constructor(
    private readonly navCtrl: NavController,
    private readonly modalCtrl: ModalController,
    public readonly cartService: CartService,
    private readonly menuService: MealMenuService,
    public readonly orderService: OrderService,
    private readonly instoreService: InStoreProductsService
  ) {}

  ngOnInit() {
    this.deliveryDays =
      this.order.type === OrderType.DELIVERY
        ? new Set<WeekDay>(this.order.items.map((item) => item.day as WeekDay))
        : null;

    this.weeksInOrder$ = this.menuService.weeklyMenus$.pipe(
      take(1),
      map((menus) => {
        const thisWeekMenu = menus!.find(
          (m) => m.weekNumber === getCurrentWeekNumber()
        );
        const nextWeekMenu = menus!.find(
          (m) => m.weekNumber === getNextWeekNumber()
        );
        const orderedMenuIds = new Set<number>(
          this.order.items.map((item) => item.weeklyMenuId)
        );
        const res: WeekIndex[] = [];
        if (thisWeekMenu && orderedMenuIds.has(thisWeekMenu.id)) {
          res.push(WeekIndex.THIS_WEEK);
        }
        if (nextWeekMenu && orderedMenuIds.has(nextWeekMenu.id)) {
          res.push(WeekIndex.NEXT_WEEK);
        }
        return new Set(res);
      })
    );

    of(null)
      .pipe(delay(500))
      .subscribe(() => {
        this.cartService.clearCart();
      });
  }

  ngOnDestroy() {
    this.instoreService.finishInstoreSession();
  }

  onGoBackToDashboard(): void {
    this.modalCtrl.dismiss();
  }
}
